import React from 'react';
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, Mail, LogOut } from 'lucide-react';

const PendingApprovalPage = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-teal-50 to-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
            <Clock className="h-8 w-8 text-amber-600" />
          </div>
          <CardTitle className="text-2xl">Account Pending Approval</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-gray-600">
            Thank you for registering, <strong>{user.name}</strong>!
          </p>
          <p className="text-gray-600">
            Your account is currently being reviewed by our administrative team. 
            You will receive an email notification once your account has been approved.
          </p>
          
          <div className="bg-teal-50 p-4 rounded-lg">
            <p className="text-sm text-teal-700">
              <Mail className="h-4 w-4 inline mr-2" />
              We'll notify you at: <strong>{user.email}</strong>
            </p>
          </div>

          <div className="text-sm text-gray-500 mt-6">
            <p>This typically takes 1-2 business days.</p>
            <p>For urgent requests, please contact us at:</p>
            <p className="font-medium text-teal-600 mt-1">hospice@goodwinliving.org</p>
          </div>

          <Button 
            variant="outline" 
            className="mt-6"
            onClick={handleLogout}
          >
            <LogOut className="h-4 w-4 mr-2" />
            Sign Out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PendingApprovalPage;
